<svg width="73" height="50" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M2 0a2 2 0 0 0-2 2v46a2 2 0 0 0 2 2h63a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H25V2a2 2 0 0 0-2-2H2z"
    fill="#CABC51"
  />
  <path
    d="M2.852 6.905A2 2 0 0 1 4.85 5h61.053a2 2 0 0 1 1.998 2.095l-1.753 37A2 2 0 0 1 64.15 46H3.097a2 2 0 0 1-1.998-2.095l1.753-37z"
    fill="#DDDDE4"
  />
  <path
    d="M3.823 8.856A2 2 0 0 1 5.818 7h62.033a2 2 0 0 1 1.994 2.144l-2.668 37A2 2 0 0 1 65.182 48H3.149a2 2 0 0 1-1.994-2.144l2.668-37z"
    fill="#F7F7F9"
  />
  <path
    d="M5.75 10.71A2 2 0 0 1 7.729 9h62.957a2 2 0 0 1 1.979 2.29l-5.415 37A2 2 0 0 1 65.271 50H2.314a2 2 0 0 1-1.979-2.29l5.415-37z"
    fill="#FFF8C0"
  />
</svg>
